import PropTypes from 'prop-types';

import CustomIcon from '../../CustomIcons';
import NavLoader from './NavLoader';

function NavigationItem({ item, isLoader, handleChildNav, loaderNavLabel, pathname, setHostName }) {
  const {
    link,
    link: { href: rawHref },
    items = []
  } = item;
  const isActiveTab = pathname.toLowerCase().includes(rawHref.toLowerCase());
  const { title, iconClass, target, href } = setHostName({ link });
  return (
    <>
      <li className={`flex-group global-nav__item ${isActiveTab ? 'active-tab' : ''}`}>
        <a target={target} href={href}>
          {!!iconClass && (
            <i>
              <CustomIcon size="20" type={iconClass} className={iconClass} fill="#FFF" />
            </i>
          )}
          {title}
        </a>
        {!!items.length && (
          <button className="header__btn" type="button" onClick={() => handleChildNav(item)} aria-label="remove">
            <CustomIcon size="20" type="fwdArrow" className="right-arrow" fill="#FFF" />
          </button>
        )}
      </li>
      {isLoader && <NavLoader text={loaderNavLabel} />}
    </>
  );
}

NavigationItem.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  handleChildNav: PropTypes.func.isRequired,
  loaderNavLabel: PropTypes.string.isRequired,
  setHostName: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  isLoader: PropTypes.bool
};

NavigationItem.defaultProps = {
  pathname: '',
  isLoader: false
};

export default NavigationItem;
